import { createContext, useContext } from 'react';
import type { GeneralID, TourData } from '@types';

export interface ScenesCopyState {
  query: string;
  albumId: number;
  targetTid?: string;
  sort: number;
  targetCategoryId?: number;
  isNewCategory?: boolean;
  targetTourData?: TourData;
}

export interface ScenesCopyProps {
  level: '作品' | '一级分组' | '二级分组' | '场景';
  categoryId?: number;
  subCategoryId?: number;
  sceneIds?: GeneralID[];
}

export interface ScenesCopyValue extends ScenesCopyState, ScenesCopyProps {
  setScenesCopyState: (state: Partial<ScenesCopyState>) => void;
}

export const defaultScenesCopyState: ScenesCopyState = {
  query: '',
  albumId: 0,
  sort: 0,
};

export const ScenesCopyContext = createContext<ScenesCopyValue>({
  level: '作品',
  ...defaultScenesCopyState,
  setScenesCopyState: () => {},
});

export const useScenesCopyContext = () => {
  const context = useContext(ScenesCopyContext);
  if (context === undefined) {
    throw new Error(
      'useScenesCopyContext must be used within a ScenesCopyContext.Provider'
    );
  }
  return context;
};
